import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "family-group-list-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Groups", -1)

import FamilyGroupList from './FamilyGroupList.vue'
import { usePageTitle } from '@/util/AppUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupListPage',
  setup(__props) {

usePageTitle("Groups")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(FamilyGroupList)
  ]))
}
}

})